/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Percent_Of_Your_EarningsInputs */

const en_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% of your earnings`)
};

const es_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de tus ganancias`)
};

const fr_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% de vos gains`)
};

const de_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% deiner Einnahmen`)
};

const ja_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% を保持します`)
};

const zh_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% 的收益`)
};

const ar_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% من أرباحك`)
};

const id_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% dari penghasilan Anda`)
};

const it_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% dei tuoi guadagni`)
};

const ru_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% от вашего дохода`)
};

const pt_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% dos seus ganhos`)
};

const ko_percent_of_your_earnings = /** @type {(inputs: Percent_Of_Your_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% 를 유지하세요`)
};

/**
* | output |
* | --- |
* | "% of your earnings" |
*
* @param {Percent_Of_Your_EarningsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const percent_of_your_earnings = /** @type {((inputs?: Percent_Of_Your_EarningsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Percent_Of_Your_EarningsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_percent_of_your_earnings(inputs)
	if (locale === "es") return es_percent_of_your_earnings(inputs)
	if (locale === "fr") return fr_percent_of_your_earnings(inputs)
	if (locale === "de") return de_percent_of_your_earnings(inputs)
	if (locale === "ja") return ja_percent_of_your_earnings(inputs)
	if (locale === "zh") return zh_percent_of_your_earnings(inputs)
	if (locale === "ar") return ar_percent_of_your_earnings(inputs)
	if (locale === "id") return id_percent_of_your_earnings(inputs)
	if (locale === "it") return it_percent_of_your_earnings(inputs)
	if (locale === "ru") return ru_percent_of_your_earnings(inputs)
	if (locale === "pt") return pt_percent_of_your_earnings(inputs)
	return ko_percent_of_your_earnings(inputs)
});